import React from "react";

const Dashboard = React.lazy(() => import("../views/operation/Dashboard"));
const ParticipantForm = React.lazy(() => import("../views/operation/ParticipantForm"));
const Quiz = React.lazy(() => import("../views/operation/Quiz"));
const Events = React.lazy(() => import("../views/operation/Event"));

const routes =  [
    { path: "/event", name: "Event", component: Events},
    { path: "/dashboard", name: "Dashboard", component: Dashboard},
    { path: "/register", name: "Registration", component: ParticipantForm},
    { path: "/quiz", name: "Quiz", component: Quiz},
];

export default routes;